
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.79 0C5.721 0 0 5.735 0 12.802c0 7.067 5.722 12.802 12.79 12.802 7.079 0 12.814-5.735 12.814-12.802C25.604 5.735 19.869 0 12.789 0zm.012 23.044A10.239 10.239 0 012.56 12.802 10.239 10.239 0 0112.802 2.56a10.239 10.239 0 0110.242 10.242 10.239 10.239 0 01-10.242 10.242z","fill":"#2C2C2C"}}),_c('path',{attrs:{"d":"M13.443 6.4h-1.92v7.682l6.72 4.033.96-1.575-5.76-3.418V6.4z","fill":"#2C2C2C"}})])
          )
        }
      }
    